import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { SwitchToggle } from "../../Components/TableHelper";
import { useFormik } from "formik";
import { pageBannerSchema } from "../../Validation/Validation";
import axiosInstance from "../../axiosInterceptor";
import { toast } from "react-toastify";
import CodeEditor from "../../Components/CodeEditor";
import ImageUploadDragAndDrop from "../../Components/ImageUploadDragAndDrop";
import Breadcrumb from "../../Components/Breadcrumb";
import Select from "react-select";
import { customStyles } from "../../utils/constant";

const AddPageBanner = () => {
  const navigator = useNavigate();
  const location = useLocation();
  const editData = location.state;
  const [loading, setLoading] = useState(false);
  const editingId = editData?._id;
  const [menuData, setMenuData] = useState([]);
  const [subMenuData, setSubMenuData] = useState([]);

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const res = await axiosInstance.get("menu/getallmenu");
        setMenuData(res.data?.data || []);
      } catch (err) {
        setMenuData([]);
      }
    };
    fetchMenuData();
  }, []);

  const initalvalues = {
    title: editData?.title || "",
    description: editData?.description || "",
    badge: editData?.badge || "",
    desktopImage: editData?.desktopImage,
    mobileImage: editData?.mobileImage,
    isActive: editData?.isActive,
    menuId: editData?.menuId?._id || null,
    subMenuId: editData?.subMenuId?._id || null,
  };
  const { values, errors, handleSubmit, handleChange, setFieldValue, touched } =
    useFormik({
      initialValues: initalvalues,
      validationSchema: pageBannerSchema,
      onSubmit: async (values) => {
        setLoading(true);
        try {
          const formData = new FormData();
          formData.append("title", values.title);
          formData.append("description", values.description || "");
          formData.append("badge", values.badge || "");
          formData.append("isActive", values.isActive || false);
          formData.append("menuId", values.menuId || null);
          if (values.subMenuId) {
            formData.append("subMenuId", values.subMenuId || null);
          }
          if (values.desktopImage instanceof File) {
            formData.append("desktopImage", values.desktopImage);
          }

          if (values.mobileImage instanceof File) {
            formData.append("mobileImage", values.mobileImage);
          }
          const response = editingId
            ? await axiosInstance.put(
              `/pagebanner/update/${editingId}`,
              formData,
            )
            : await axiosInstance.post(
              "/pagebanner/create",
              formData,
            );

          if (response.status === 200) {
            toast.success(response.data.message);
            navigator("/page-banners");
          }
        } catch (error) {
          toast.error(error.response?.data?.message);
          return error;
        } finally {
          setLoading(false);
        }
      },
    });

  useEffect(() => {
    const fetchSubMenuData = async () => {
      try {
        if (!values.menuId) {
          setSubMenuData([]);
          setFieldValue("subMenuId", null);
          return;
        }

        const response = await axiosInstance.get(
          `/subMenu/getSubMenuByMenu/${values.menuId}`,
        );

        setSubMenuData(response.data?.data || []);
      } catch (error) {
        setSubMenuData([]);
      }
    };

    fetchSubMenuData();
  }, [values.menuId]);

  const breadcrumbdata = [
    { label: "Home", path: "/dashboard" },
    { label: "Page Banners", path: "/page-banners" },
    { label: editingId ? "Update" : "Add", path: "*" },
  ];

  const menuOptions = menuData.map((item) => ({
    label: item.menuName,
    value: item._id,
  }));

  const subMenuOptions =
    subMenuData &&
    subMenuData?.length > 0 &&
    subMenuData?.map((item) => ({
      label: item.subMenuName,
      value: item._id,
    }));

  const columnClass =
    subMenuOptions && subMenuOptions.length > 0
      ? "col-sm-6 col-lg-6"
      : "col-sm-6";
  return (
    <>
      <div className="content-wrapper">
        <div className="page-header mb-3">
          <h3 className="custom-page-title">
            {editingId ? "Update" : "Add"} Page Banner
          </h3>
          <Breadcrumb items={breadcrumbdata} />
        </div>
        <div className="col-md-12 grid-margin stretch-card p-0">
          <div className="card m-0">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className={columnClass}>

                    <div className="form-group">
                      <label htmlFor="menuId" className="col-form-label ">
                        Select Menu
                      </label>
                      <Select
                        placeholder=" Select Menu"
                        isClearable
                        styles={customStyles}
                        options={menuOptions}
                        value={
                          menuOptions.find(
                            (opt) => opt.value === values.menuId,
                          ) || null
                        }
                        onChange={(option) => {
                          setFieldValue("menuId", option ? option.value : null);
                        }}
                        name="menuId"
                      />
                      {touched.menuId && errors.menuId && (
                        <small className="text-danger">{errors.menuId}</small>
                      )}
                    </div>
                  </div>

                  {subMenuOptions && subMenuOptions?.length > 0 && (
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="subMenuId" className="col-form-label">
                          Select Sub Menu
                        </label>

                        <Select
                          placeholder="Select Sub Menu"
                          isClearable
                          styles={customStyles}
                          options={subMenuOptions}
                          value={
                            subMenuOptions.find(
                              (opt) => opt.value === values.subMenuId,
                            ) || null
                          }
                          onChange={(option) => {
                            setFieldValue(
                              "subMenuId",
                              option ? option.value : null,
                            );
                          }}
                          name="subMenuId"
                          isDisabled={!values.menuId}
                        />

                        {touched.subMenuId && errors.subMenuId && (
                          <small className="text-danger">
                            {errors.subMenuId}
                          </small>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label htmlFor="banner-badge" className="col-form-label ">
                        Banner Badge
                      </label>
                      <input
                        type="text"
                        className="form-control border border-dark"
                        id="banner-badge"
                        name="badge"
                        placeholder="Enter banner badge"
                        value={values.badge}
                        onChange={handleChange}
                      />
                      {touched.badge && errors.badge && (
                        <small className="text-danger">{errors.badge}</small>
                      )}
                    </div>
                  </div>
                  <div className={columnClass}>
                    <div className="form-group">
                      <label htmlFor="banner-title" className="col-form-label ">
                        Page title
                      </label>
                      <CodeEditor
                        value={values.title}
                        onChange={(val) => setFieldValue("title", val)}
                        placeholder="Enter a page title"
                      />

                      {touched.title && errors.title && (
                        <small className="text-danger">{errors.title}</small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="form-group">
                      <label
                        htmlFor="slider-description"
                        className="col-form-label "
                      >
                        Page description
                      </label>

                      <CodeEditor
                        value={values.description}
                        onChange={(val) => setFieldValue("description", val)}
                        placeholder="Enter a page description"
                      />

                      {touched.description && errors.description && (
                        <small className="text-danger">
                          {errors.description}
                        </small>
                      )}
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="banner-desktopImage"
                      label={`Banner Image (1800px X 750px)`}
                      value={values.desktopImage}
                      onChange={(file) => setFieldValue("desktopImage", file)}
                    />
                  </div>
                  <div className="col-sm-6">
                    <ImageUploadDragAndDrop
                      id="banner-mobileImage"
                      label={`Mobile Image (600px X 900px)`}
                      value={values.mobileImage}
                      onChange={(file) => setFieldValue("mobileImage", file)}
                      error={errors.mobileImage}
                      touched={touched.mobileImage}
                    />
                  </div>
                  <div className="col-md-12 mt-4">
                    <SwitchToggle
                      checked={values.isActive}
                      onChange={(val) => setFieldValue("isActive", val)}
                    />
                  </div>
                </div>

                <div className="text-center mt-4">
                  <Button type="submit" color="primary" disabled={loading}>
                    {loading ? (
                      <span className="d-inline-flex align-items-center gap-2">
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Processing...
                      </span>
                    ) : (
                      "Save"
                    )}
                  </Button>

                  <Link to="/page-banners">
                    <Button color="danger mx-2">Cancel </Button>
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPageBanner;
